import React, {Component} from 'react'
import { STATUS, PROTOCOL, ONLY_FTP_HOSTS } from './../lib/helper'
import BVLoader from './bvloader'
import { Form } from 'formsy-react'
import SubHeader from './subheader'
import Error from './error'
import Validating from './validating'
import HostSelector from './hostselector'
import FAQs from './faqs'
import Forms from './forms'
import Input from './input'
import _ from 'underscore'
import PropTypes from 'prop-types'
import BVError from './notifications/error'
import AdvancedOptionsForm from './forms/advancedoptionsform'
import { HOSTS } from './../lib/helper'
import FlywheelForm from './flywheel/flywheelform'
import FlywheelLoader from './flywheel/flywheelloader'
import DreamHostForm from './dreamhost/dreamhostform'
import CloudwaysForm from './cloudways/cloudwaysform'
import CloudwaysLoader from './cloudways/cloudwaysloader'
import WPEngineForm from './wpengine/wpengineform'
import WPEngineLoader from './wpengine/wpengineloader'
import NexcessForm from './nexcess/nexcessform'
import PressableForm from './pressable/pressableform'
import WPCOMForm from './wpcom/wpcomform'
import WPCOMLoader from './wpcom/wpcomloader'
import TokenInput from './tokeninput'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'

const MIGRATIONTYPE = { FTP: 1, KEY: 2 }
class Validation extends Component{
	constructor(props){
		super(props)
		this.state = {
			fields: {},
			loading: <BVLoader />,
			validating: false,
			currentForm: this.hasKeySupport() ? MIGRATIONTYPE.KEY : MIGRATIONTYPE.FTP
		}
		this.handleSubmit = this.handleSubmit.bind(this)
		this.handleClick = this.handleClick.bind(this)
		this.changeHost = this.changeHost.bind(this)
		this.cancel = this.cancel.bind(this)
		this.updateDirectories = this.updateDirectories.bind(this)
		this.resetResponseError = this.resetResponseError.bind(this)
		this.getDirectoryList = this.getDirectoryList.bind(this)
		this.getTablesList = this.getTablesList.bind(this)
		this.changeSelection = this.changeSelection.bind(this)
		this.changeTableSelection = this.changeTableSelection.bind(this)
		this.selectAllDirectories = this.selectAllDirectories.bind(this)
	}

	componentWillMount() {
		const { migrate } = this.props
		if (migrate.get('migration_complete') === STATUS.INITIALIZING && migrate.get('destination_host') === "Unknown") {
			this.setState({ showHostSelector: true })
		} else {
			this.setState({ selectedHost: migrate.get('destination_host') })
		}
		this.checkErrors(migrate)
	}

	UNSAFE_componentWillReceiveProps(nextProps){
		const { migrate } = nextProps
		if (migrate.get('destination_host') === "Unknown"){
			this.checkErrors(migrate)
		} else if (_.isEqual(this.state.selectedHost, migrate.get('destination_host'))) {
			this.checkErrors(migrate)
		}
	}

	componentDidUpdate(prevProps){
		const { migrate } = this.props
		const { currentForm } = this.state
		if (prevProps.migrate.get('errors') !== migrate.get('errors')) {
			const fields = migrate.getIn(['errors', 'fields'])
			const switchToFtp = fields && fields.includes('open_ftp')
			const notInFtp = currentForm !== MIGRATIONTYPE.FTP
			if (switchToFtp && notInFtp) {
				this.setState({ currentForm: MIGRATIONTYPE.FTP })
			}
			this.checkErrors(migrate)
		}
	}

	updateDirectories(data){
		this.setState({directoryList: data})
	}

	updateTables(data){
		this.setState({tablesList: data})
	}

	checkErrors(migrate){
		const errors = migrate.get('errors')
		if (errors.size > 0) {
			this.setState({ error_visible: true})
		}
		this.setState({ loading: false, validating: false })
	}

	handleSubmit(data){
		const { actions, params } = this.props
		const { directoryList, tablesList } = this.state
		this.setState({ fields: data, loading: <BVLoader />, response: false, failed_fields: false })
		if (!data['protocol']){
			data['protocol'] =  PROTOCOL[data.type.toUpperCase()]
		}
		let newSelectedDirectories = []
		if (directoryList && directoryList.length > 0) {
			directoryList.forEach(data => {
				if (!data.isDisabled && data.selected) {
					newSelectedDirectories.push(data.name)
				}
			})
		}
		let newSelectedTables = {}
		if (tablesList && tablesList.length > 0) {
			tablesList.forEach(data => {
				newSelectedTables[data.name] = data.selected
			})
		}
		data = _.extend(data, {key: params['gid'], selectedDirectories: newSelectedDirectories, selectedTables: newSelectedTables})
		actions.validateMigration(data)
			.then(() => {
				this.setState({loading: false})
			})
			.catch((res) => {
				this.setState({response: "Something went wrong. Please contact us or try again later.", loading: false})
			})
	}

	changeHost(data) {
		const newState = {
			selectedHost: data,
			showHostSelector: false,
		}
		if (HOSTS.ELEMENTOR === data) {
			newState.currentForm = MIGRATIONTYPE.KEY
		}
		this.setState(newState)
	}

	handleClick(event){
		event.preventDefault()
		this.setState({ error_visible: false, showHostSelector: true, fields: {}})
	}

	cancel(){
		this.setState({ showHostSelector: false })
	}

	getHost(){
		const { selectedHost } = this.state
		const { migrate } = this.props
		let currentHost = selectedHost
		let protocol = migrate.get('protocol')
		if (currentHost === HOSTS.UNKNOWN) {
			return protocol === PROTOCOL.CPANEL ? HOSTS.CPANEL : HOSTS.GENERIC
		} else {
			return currentHost
		}
	}

	error(){
		const { migrate } = this.props
		const { error_visible, response } = this.state
		if (error_visible) {
			return <Error error_message={migrate.getIn(['errors', 'message'])}/>
		} else if (response) {
			return <Error error_message={response}/>
		}
		return
	}

	error_fields(){
		const { migrate } = this.props
		const { error_visible } = this.state
		if (error_visible) {
			return migrate.getIn(['errors', 'fields']).toJS()
		}
		return []
	}
	resetResponseError(){
		this.setState({response: false})
	}

	directoriesSelectAllDisabled() {
		const { directoryList } = this.state
		return _.all(directoryList, directory => directory.isDisabled)
	}

	tablesSelectAllDisabled = () => {
		const { tablesList } = this.state
		return _.all(tablesList, table => table.isDisabled)
	}

	allDirectoriesSelected() {
		const { directoryList } = this.state
		return _.all(directoryList, directory => directory.selected)
	}

	allTablesSelected = () => {
		const { tablesList } = this.state
		return _.all(tablesList, table => table.selected)
	}

	selectAllDirectories() {
		const { directoryList } = this.state
		let allSelected = this.allDirectoriesSelected()
		let newstate = directoryList.map((directory) => (
			{
				name: directory.name,
				selected: directory.isDisabled ? directory.selected : !allSelected,
				isDisabled: directory.isDisabled
			}
		))
		this.updateDirectories(newstate)
	}

	selectAllTables = () => {
		const { tablesList } = this.state
		let allSelected = this.allTablesSelected()
		let newstate = tablesList.map((table) => (
			{
				name: table.name,
				selected: table.isDisabled ? table.selected : !allSelected,
				isDisabled: table.isDisabled
			}
		))
		this.updateTables(newstate)
	}

	changeSelection(name) {
		const { directoryList } = this.state
		let newstate = directoryList.map((directory) => (
			{
				name: directory.name,
				selected: (directory.name === name && !directory.isDisabled ? !directory.selected : directory.selected),
				isDisabled: directory.isDisabled
			}
		))
		this.updateDirectories(newstate)
	}

	changeTableSelection(name) {
		const { tablesList } = this.state
		let newstate = tablesList.map((table) => (
			{
				name: table.name,
				selected: (table.name === name && !table.isDisabled ? !table.selected : table.selected),
				isDisabled: table.isDisabled
			}
		))
		this.updateTables(newstate)
	}

	getDirectoryList() {
		const { actions, params } = this.props
		const { directoryList } = this.state
		if (!directoryList) {
			this.setState({loading: <BVLoader />, fetchingDirectories: true})
			actions.fetchDirectoryList({key: params.gid})
				.then(res => {
					let list = res.data.directory_list
					if (list && list.length>0) {
						this.updateDirectories(list)
					} else {
						let message = "Unable to fetch Directory List from Source Site. Please retry or Contact us!"
						this.setState({response: message})
					}
					this.setState({loading: false, fetchingDirectories: false})
				})
				.catch(error => {
					let message = error.data.message
					this.setState({response: message})
					this.setState({loading: false, fetchingDirectories: false})
				})
		}
	}
	getTablesList() {
		const { actions, params } = this.props
		const { tablesList } = this.state
		if (!tablesList) {
			this.setState({loading: <BVLoader />, fetchingTables: true})
			actions.fetchTablesList({key: params.gid})
				.then(res => {
					let list = res.data.tables_list
					if (list && list.length > 0) {
						this.updateTables(list)
					} else {
						let message = "Unable to fetch Tables List from Source Site. Please retry or Contact us!"
						this.setState({response: message})
					}
					this.setState({loading: false, fetchingTables: false})
				})
				.catch(error => {
					let message = error.data.message
					this.setState({response: message})
					this.setState({loading: false, fetchingTables: false})
				})
		}
	}
	hasKeySupport = () => {
		const { bvKeyMigrationEnabled, migrate } = this.props
		return bvKeyMigrationEnabled && !ONLY_FTP_HOSTS.includes(migrate.get('origin'))
	}
	downloadPlugin = () => {
		let manualDownloadUrl = `/migration/download_plugin?plugin_name=${PLUGNAMES.MIGRATEGURU}`
		window.open(manualDownloadUrl, '_self')
	}
	getMoreInfo = () => {
		return (
			<OverlayTrigger
				placement="right"
				overlay={
					<Tooltip id="migration-key-info">
						<ol className='align-left'>
							<li>1. <u className='pointer-on-hover' onClick={this.downloadPlugin}>Download</u> MigrateGuru Plugin {'>='} <b>v4.85</b></li>
							<li>2. Install Plugin on your destination site</li>
							<li>3. Copy Migration Key</li>
						</ol>
					</Tooltip>
				}
			>
				<button
					type="button"
					className='bv-underline font-600 pointer-on-hover position-absolute'
					style={{background: 'transparent', border: 0, color: 'inherit', font: 'inherit', padding: 0, right: '15px'}}
				>
					What&apos;s this?
				</button>
			</OverlayTrigger>
		)
	}
	render() {
		const { actions, migrate, params, history, bvKeyMigrationEnabled, httpMigrationEnabled, cwsAutoscaleEnabled, showAutomatticHost } = this.props
		const { showHostSelector, fields, loading, response, directoryList, tablesList, fetchingDirectories, fetchingTables, currentForm } = this.state
		const migStatus = migrate.get('migration_complete')
		const is_migrateguru = migrate.get('is_migrateguru')
		let currentHost = this.getHost()
		let message
		let className = "col-md-12 col-xs-12"
		const error_fields = this.error_fields()
		if (migStatus === STATUS.INITIALIZING && showHostSelector && !currentHost){
			message = "Select the host you are migrating to."
			return (
				<div>
					<SubHeader message={message}/>
					<HostSelector submit={this.changeHost} showAutomatticHost={showAutomatticHost}/>
				</div>
			)
		} else if (showHostSelector && is_migrateguru){
			message = "Please select the destination host."
			return (
				<div>
					<SubHeader message={message}/>
					<HostSelector submit={this.changeHost} cancel={this.cancel} showAutomatticHost={showAutomatticHost}/>
				</div>
			)
		} else if (migStatus === STATUS.VALIDATING){
			message = currentHost === "Sandbox" ? "Your install is being created" : "Validating Details..."
			return (
				<Validating message={message} migrate={migrate}/>
			)
		} else {
			switch (migrate.get('origin')) {
			case ORIGIN.FLYWHEEL:
				if (loading && !fetchingDirectories && !fetchingTables) {
					return <FlywheelLoader />
				} else {
					return <FlywheelForm
						handleSubmit={this.handleSubmit}
						fields={fields}
						params={params}
						error={this.error()}
						errors={error_fields}
						directoryList={directoryList}
						tablesList={tablesList}
						fetchingDirectories={fetchingDirectories}
						fetchingTables={fetchingTables}
						getDirectoryList={this.getDirectoryList}
						getTablesList={this.getTablesList}
						changeSelection={this.changeSelection}
						changeTableSelection={this.changeTableSelection}
					/>
				}
			case ORIGIN.DREAMHOST:
				return <DreamHostForm
					history={history}
					loading={loading}
					handleSubmit={this.handleSubmit}
					migrate={migrate}
					fields={fields}
					params={params}
					httpMigrationEnabled={httpMigrationEnabled}
					error={this.error()}
					errors={error_fields}
					directoryList={directoryList}
					tablesList={tablesList}
					getDirectoryList={this.getDirectoryList}
					getTablesList={this.getTablesList}
					changeSelection={this.changeSelection}
					changeTableSelection={this.changeTableSelection}
					directoriesSelectAllDisabled={this.directoriesSelectAllDisabled()}
					allDirectoriesSelected={this.allDirectoriesSelected()}
					selectAllDirectories={this.selectAllDirectories}
					tablesSelectAllDisabled={this.tablesSelectAllDisabled()}
					allTablesSelected={this.allTablesSelected()}
					selectAllTables={this.selectAllTables}
				/>
			case ORIGIN.AUTOMATTIC:
				if (loading && !fetchingDirectories && !fetchingTables) {
					return <WPCOMLoader message="Verifying your information"/>
				} else {
					return <WPCOMForm
						loading={loading}
						handleSubmit={this.handleSubmit}
						migrate={migrate}
						fields={fields}
						params={params}
						error={this.error()}
						errors={error_fields}
						directoryList={directoryList}
						tablesList={tablesList}
						fetchingDirectories={fetchingDirectories}
						fetchingTables={fetchingTables}
						getDirectoryList={this.getDirectoryList}
						getTablesList={this.getTablesList}
						changeSelection={this.changeSelection}
						changeTableSelection={this.changeTableSelection}
						directoriesSelectAllDisabled={this.directoriesSelectAllDisabled()}
						allDirectoriesSelected={this.allDirectoriesSelected()}
						selectAllDirectories={this.selectAllDirectories}
						tablesSelectAllDisabled={this.tablesSelectAllDisabled()}
						allTablesSelected={this.allTablesSelected()}
						selectAllTables={this.selectAllTables}
					/>
				}
			case ORIGIN.CLOUDWAYS:
				if (loading && !fetchingDirectories && !fetchingTables) {
					return <CloudwaysLoader message="Validating Details"/>
				} else {
					return <CloudwaysForm
						history={history}
						loading={loading}
						handleSubmit={this.handleSubmit}
						fields={fields}
						params={params}
						error={this.error()}
						errors={error_fields}
						directoryList={directoryList}
						tablesList={tablesList}
						fetchingDirectories={fetchingDirectories}
						fetchingTables={fetchingTables}
						getDirectoryList={this.getDirectoryList}
						getTablesList={this.getTablesList}
						changeSelection={this.changeSelection}
						changeTableSelection={this.changeTableSelection}
						cwsAutoscaleEnabled={cwsAutoscaleEnabled}
					/>
				}
			case ORIGIN.WPENGINE:
				if (loading && !fetchingDirectories && !fetchingTables) {
					return <WPEngineLoader />
				} else {
					return <WPEngineForm
						actions={actions}
						history={history}
						migrate={migrate}
						handleSubmit={this.handleSubmit}
						fields={fields}
						params={params}
						error={this.error()}
						errors={error_fields}
						directoryList={directoryList}
						tablesList={tablesList}
						fetchingDirectories={fetchingDirectories}
						fetchingTables={fetchingTables}
						getDirectoryList={this.getDirectoryList}
						getTablesList={this.getTablesList}
						changeSelection={this.changeSelection}
						changeTableSelection={this.changeTableSelection}
					/>
				}
			case ORIGIN.LIQUIDWEB:
			case ORIGIN.NEXCESS:
				return <NexcessForm
					loading={loading}
					handleSubmit={this.handleSubmit}
					migrate={migrate}
					fields={fields}
					params={params}
					error={this.error()}
					errors={error_fields}
					directoryList={directoryList}
					tablesList={tablesList}
					getDirectoryList={this.getDirectoryList}
					getTablesList={this.getTablesList}
					changeSelection={this.changeSelection}
					changeTableSelection={this.changeTableSelection}
					directoriesSelectAllDisabled={this.directoriesSelectAllDisabled()}
					allDirectoriesSelected={this.allDirectoriesSelected()}
					selectAllDirectories={this.selectAllDirectories}
					tablesSelectAllDisabled={this.tablesSelectAllDisabled()}
					allTablesSelected={this.allTablesSelected()}
					selectAllTables={this.selectAllTables}
				/>
			case ORIGIN.PRESSABLE:
				return <PressableForm
					history={history}
					loading={loading}
					handleSubmit={this.handleSubmit}
					migrate={migrate}
					fields={fields}
					params={params}
					error={this.error()}
					errors={error_fields}
					directoryList={directoryList}
					tablesList={tablesList}
					getDirectoryList={this.getDirectoryList}
					getTablesList={this.getTablesList}
					changeSelection={this.changeSelection}
					changeTableSelection={this.changeTableSelection}
					directoriesSelectAllDisabled={this.directoriesSelectAllDisabled()}
					allDirectoriesSelected={this.allDirectoriesSelected()}
					selectAllDirectories={this.selectAllDirectories}
					tablesSelectAllDisabled={this.tablesSelectAllDisabled()}
					allTablesSelected={this.allTablesSelected()}
					selectAllTables={this.selectAllTables}
				/>
			default:
				if (currentHost === "Generic"){
					message = MIGRATIONTYPE.KEY === currentForm ? 'Migrating Using Key' : `Migrating Using FTP`
				} else {
					message = `Migrating to ${currentHost.toUpperCase()}`
				}
				if (_.contains(error_fields, 'bv_migration_key')) {
					className += " error-field"
				}
				return (
					<div className="bv-body">
						{loading}
						{response ? <BVError message={response} onDismiss={this.resetResponseError}/> : null }
						<SubHeader message={message}/>
						<div className="col-xs-9 col-md-9 center-dom text-center container" >
							<div id="mg-old-form-divider" className="row">
								<Form onSubmit={this.handleSubmit} className="bv-form-label-left-align mg-form" style={{ paddingTop: "0px"}}>
									<div className="col-xs-8 col-md-8 bv-left-section-container">
										{ this.error() }
										<div className="col-xs-10 col-md-10 bv-form mg-ftp-credentials p-form-fix" style={{ paddingTop: "1.8rem", paddingBottom: "0px" }}>
											{MIGRATIONTYPE.KEY === currentForm ?
												<TokenInput
													className={className}
													value={fields['bv_migration_key'] || ''}
													required={true}
													name="bv_migration_key"
													moreInfo={this.getMoreInfo()}
													protocol={PROTOCOL.HTTP}
													placeholder="Eg. aHR0cDovLzEyNy4wLjAuMS9zaXtTGZzQ="
													title="MigrateGuru Migration Key"
													formType={currentHost}
													toggleForm={() => this.setState({currentForm: MIGRATIONTYPE.FTP})}
												/> : <div>
													{this.hasKeySupport() ? <p className="pt-1 pb-2 fw-600 text-right bv-underline">
														<a onClick={() => this.setState({currentForm: MIGRATIONTYPE.KEY})}>I Have Migration Key</a>
													</p> : null}
													<Forms formType={currentHost} fields={fields} failed_fields={error_fields} params={params} />
												</div>
											}
											<AdvancedOptionsForm
												migrate={migrate}
												errors={error_fields}
												fields={fields}
												params={params}
												directoryList={directoryList}
												tablesList={tablesList}
												getDirectoryList={this.getDirectoryList}
												getTablesList={this.getTablesList}
												changeSelection={this.changeSelection}
												changeTableSelection={this.changeTableSelection}
												directoriesSelectAllDisabled={this.directoriesSelectAllDisabled()}
												allDirectoriesSelected={this.allDirectoriesSelected()}
												selectAllDirectories={this.selectAllDirectories}
												tablesSelectAllDisabled={this.tablesSelectAllDisabled()}
												allTablesSelected={this.allTablesSelected()}
												selectAllTables={this.selectAllTables}
											/>
											<div className="row hide-field">
												{is_migrateguru ?
													<Input
														type="hidden"
														title=""
														name="origin"
														placeholder=""
														className=""
														value="migrateguru"
													/>
													:
													<span></span>
												}
												<Input
													type="hidden"
													title=""
													name="bvsrc"
													placeholder=""
													classname=""
													value="wpplugin"
												/>
											</div>
										</div>
									</div>
									<div className="col-md-4 col-xs-4 bv-ftp-info-section bv-text-left-align">
										<FAQs formType={currentHost} bvKeyMigrationEnabled={bvKeyMigrationEnabled && !ONLY_FTP_HOSTS.includes(migrate.get('origin'))}/>
									</div>
									<div className="col-xs-12 col-md-12 bv-footer">
										<div className="row">
											<input type="submit" value="Migrate" className="bv-primary-button"/>
											{ is_migrateguru ? <a href="" onClick={this.handleClick} className="bv-secondary-button">Change Host</a> : <span></span> }
										</div>
									</div>
								</Form>
							</div>
						</div>
					</div>
				)
			}
		}
	}
}

Validation.propTypes = {
	migrate: PropTypes.object,
	actions: PropTypes.object,
	params: PropTypes.object,
	bvKeyMigrationEnabled: PropTypes.bool,
	httpMigrationEnabled: PropTypes.bool
}

export default Validation
